import { FC } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useRowToggle } from "../../../../../components/ui";

type Props = {
    label: string;
    selected: boolean;
    onClick: () => void;
};

/** Linha selecionável genérica do wizard (check circular + rótulo). */
const SelectableOptionRow: FC<Props> = ({ label, selected, onClick }) => {
    const theme = useTheme();
    const toggleProps = useRowToggle(onClick, { checked: selected, label });

    return (
        <Box
            {...toggleProps}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                borderRadius: "13px",
                border: `1.5px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
                backgroundColor: selected ? theme.palette.brand.cream : "background.paper",
                px: "16px",
                py: "16px",
                cursor: "pointer",
                transition: "border-color 0.15s, background-color 0.15s",
                "&:hover": {
                    borderColor: theme.palette.primary.light,
                    backgroundColor: selected ? theme.palette.brand.cream : theme.palette.brand.surface2,
                },
                "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
            }}
        >
            {/* Check circular */}
            <Box
                sx={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
                    backgroundColor: selected ? theme.palette.primary.main : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    transition: "background-color 0.15s, border-color 0.15s",
                }}
            >
                {selected && (
                    <Box component="span" sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "primary.contrastText" }} />
                )}
            </Box>
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "text.primary" }}>{label}</Typography>
        </Box>
    );
};

export default SelectableOptionRow;
